export const PERMISSIONS_REFRESH_EVENT = 'permissions-refreshed';

export const emitPermissionsRefreshed = () => {
  if (typeof window === 'undefined') {
    return;
  }

  window.dispatchEvent(new CustomEvent(PERMISSIONS_REFRESH_EVENT));
};

export const subscribePermissionsRefresh = (handler: () => void) => {
  if (typeof window === 'undefined') {
    return () => undefined;
  }

  const listener = () => handler();
  window.addEventListener(PERMISSIONS_REFRESH_EVENT, listener);

  return () => {
    window.removeEventListener(PERMISSIONS_REFRESH_EVENT, listener);
  };
};
